module.exports = __webpack_public_path__ + "static/media/bomb-1024.888360fa.png";